import { BarChartOutlined, BranchesOutlined, GithubOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CdReleasePlan, cdDemoApi } from './cdDemoApi';

export const CdAppHeader: React.FC<{ planId: string; plan?: CdReleasePlan }> = ({ planId, plan: suppliedPlan }) => {
  const [loadedPlan, setLoadedPlan] = useState<CdReleasePlan>();
  useEffect(() => {
    if (suppliedPlan) return;
    void cdDemoApi.getPlan(planId).then(detail => setLoadedPlan(detail.plan)).catch(() => undefined);
  }, [planId, suppliedPlan]);
  const plan = suppliedPlan ?? loadedPlan;
  const targetName = plan?.targetAppName ?? 'Managed target';
  return <>
    <div className="detail-breadcrumb cd-breadcrumb"><Link to="/cd/apps">Release Center</Link><span>/</span><strong>{targetName}</strong></div>
    <div className="cd-app-header">
      <span className="app-glyph app-glyph-bars"><BarChartOutlined /></span>
      <div>
        <h1>{targetName}</h1>
        <div className="cd-header-meta">
          <span><GithubOutlined /> {plan?.repository ?? 'Loading release source…'}</span>
          <span><BranchesOutlined /> {plan?.branch ?? 'main'}</span>
          <span>{plan?.environment ?? 'Environment'}</span>
          <span className="cd-managed-id">Managed App · {plan?.targetAppId ? `${plan.targetAppId.slice(0, 8)}…` : 'target not bound'}</span>
        </div>
      </div>
    </div>
  </>;
};
